import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface AdminSearchEntityParams {
  entry: any;
  service: string;
  component: string;
  rank: string | number;
  query?: string;
  source?: string;
  suggestion?: string;
  mergeFrom?: any;
  searchParams?: any;
  selectedVia?: any;
  inventoryId?: any;
  timeToMatchInSeconds?: number;
}
export class AdminSearchEntity extends BaseEntityClass {
  entry: any;
  service: string;
  component: string;
  rank?: string | number;
  query?: string;
  source?: string;
  suggestion?: string;
  mergeFrom?: any;
  searchParams?: any;
  selectedVia?: any;
  inventoryId?: any;
  timeToMatchInSeconds?: number;
  constructor(params: AdminSearchEntityParams) {
    super();
    this.type = "search";
    this.entity_version = 3;
    this.entry = params.entry;
    this.service = params.service;
    this.component = params.component;
    this.rank = params.rank;
    this.query = params.query;
    this.source = params.source;
    this.suggestion = params.suggestion;
    this.mergeFrom = params.mergeFrom;
    this.searchParams = params.searchParams;
    this.selectedVia = params.selectedVia;
    this.inventoryId = params.inventoryId;
    this.timeToMatchInSeconds = params.timeToMatchInSeconds;
  }
}
